import React from 'react';
import SPARowList from '../shared/SPARowList';
import SectionHeading from '../shared/SPASectionHeading';

interface StatusSectionProps {
  data: Record<string, unknown>;
  href?: string;
  title: string;
}

const formatValue = (value: unknown): string => {
  if (value == null) return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return JSON.stringify(value);
};

// AIDEV-NOTE: Reusable themed key-value list for system status sections.
// Used by SystemStatus for System Info, Database, Paperclip, Sidekiq, Redis, etc.
// Values can be strings, numbers, booleans, or nested objects (serialized as JSON).
// Optional href adds an "Open <title> ↗" link to a legacy page (e.g. Sidekiq → /sidekiq).
const StatusSection = ({ data, href, title }: StatusSectionProps) => {
  const entries = Object.entries(data);

  if (entries.length === 0) return null;

  return (
    <section>
      <SectionHeading href={href} title={title} />
      <SPARowList>
        {entries.map(([key, value]) => (
          <div key={key} className="tw-flex tw-gap-4">
            <span className="tw-w-60 tw-shrink-0 tw-break-words tw-text-spa-secondary">{key}</span>
            <span className="tw-min-w-0 tw-break-all">{formatValue(value)}</span>
          </div>
        ))}
      </SPARowList>
    </section>
  );
};

export default StatusSection;
